(function () {
    'use strict';

    angular.module('swif.openbase')
        .service('swifOpenbaseUtilsService', swifOpenbaseUtilsService);

    function swifOpenbaseUtilsService() {
        'ngInject';
        var service = {};

        service.insertItemInArray = function (array, index, item) {
            array.splice(index, 0, item);
        };

        return service;
    }
})();
